
import Vue, { PropType } from "vue";
import { DialogCloseType, DialogI } from "@/types/dialog";
import BaseDialog from "@/components/dialog/BaseDialog.vue";
import Card from "@/components/v2/base/Card.vue";
import Btn from "@/components/v2/base/Btn.vue";
import CompanyAdminAccessEntity from "@/components/companyAdmin/CompanyAdminAccessEntity.vue";
import { CompanyAccessDefinition, CompanyAccess } from "@prestonly/preston-common";

export default Vue.extend({
  name: "AssignAccessToCompanyUserDialog",
  components: {
    BaseDialog,
    Card,
    CompanyAdminAccessEntity,
    Btn,
  },
  props: {
    dialog: {
      type: Object as PropType<DialogI>,
      required: true,
    },
  },
  data: () => ({
    DialogCloseType,
  }),
  computed: {
    contractDetails(): CompanyAccess["contractDetails"] {
      return this.dialog.config.payload?.contractDetails;
    },
    accesses(): CompanyAccessDefinition[] {
      return this.dialog.config.payload?.accesses;
    },
    companyId(): string {
      return this.dialog.config.payload?.companyId;
    },
    pendingInvitations(): number {
      return this.dialog.config.payload?.pendingInvitations;
    },
  },
  methods: {
    submit(access: CompanyAccessDefinition) {
      this.dialog.close({
        type: DialogCloseType.SUBMITTED,
        payload: {
          access,
        },
      });
    },
  },
});
